module.exports = __webpack_public_path__ + "img/email.54407ae7.svg";